import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import RaisedButton from 'material-ui/RaisedButton';
import { ListItem } from 'material-ui/List';
import { DataTable, EmptyState, PageHeader, SelectableList, Spinner } from 'components';
import { loadReport } from 'redux/modules/reportBuilder';
import { getReports } from 'redux/modules/reporting';
import { getSocialAccounts } from 'redux/modules/organization';
import { Preview } from 'containers/ReportBuilder';
import ReportingCharts from './ReportingCharts';
var SummaryReport = (_dec = connect(function (state, props) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    reportsById: state.reportBuilder.reportsById,
    reports: state.reporting.reports && state.reporting.reports[orgId] ? state.reporting.reports[orgId] : [],
    loadingReport: state.reportBuilder.loadingReport,
    selectedClient: state.reportBuilder.selectedClient
  };
}, {
  getSocialAccounts: getSocialAccounts,
  getReports: getReports,
  loadReport: loadReport
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(SummaryReport, _Component);

  var _super = _createSuper(SummaryReport);

  function SummaryReport() {
    var _this;

    _classCallCheck(this, SummaryReport);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleRowSelection", function (selectedRows) {
      browserHistory.push({
        pathname: "/org/".concat(_this.props.params.organizationId, "/reports/summary/").concat(selectedRows.id)
      });
    });

    return _this;
  }

  _createClass(SummaryReport, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.reports.length) {
        this.props.getReports(this.props.organization.id);
      }

      this.props.loadReport(this.props.organization.id, this.props.params.reportId);
    }
    /** *******************************************************************************************
     EVENT HANDLERS
    ********************************************************************************************/

  }, {
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this2 = this;

      var filteredReports = this.props.reports && !!this.props.reports.length ? this.props.reports.filter(function (r) {
        return r.reportType === 'monthly' && !r.isArchived;
      }) : [];
      var listValue = filteredReports.findIndex(function (report) {
        return parseInt(report.id, 10) === parseInt(_this2.props.params.reportId, 10);
      });
      var hasPdf = filteredReports && filteredReports[listValue] && filteredReports[listValue].S3File;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flex: '0 0 auto',
          minHeight: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          borderRight: '1px solid silver',
          flex: '0 0 183px',
          overflow: 'hidden',
          overflowY: 'auto'
        }
      }, !this.props.gettingReports ? /*#__PURE__*/React.createElement(SelectableList, {
        defaultValue: listValue + 1,
        onChange: function onChange() {
          return false;
        },
        style: {
          paddingTop: 0
        }
      }, filteredReports.map(function (report, index) {
        return /*#__PURE__*/React.createElement(ListItem, {
          key: index,
          value: index + 1,
          primaryText: report.name,
          onClick: function onClick() {
            _this2.setState({
              listItem: index
            });

            browserHistory.push({
              pathname: "/org/".concat(_this2.props.params.organizationId, "/reports/summary/").concat(report.id)
            });
          }
        });
      })) : /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 75
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1,
          padding: 36,
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Reports - Summary Report"
      }), /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Reports",
        secondary: "Social Media Summary",
        style: hasPdf ? {
          marginBottom: 4
        } : {}
      }), this.props.reportsById && this.props.reportsById[this.props.organization.id] && this.props.reportsById[this.props.organization.id][this.props.params.reportId] && hasPdf && /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'flex-end',
          marginBottom: 8
        }
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Download Report",
        href: filteredReports[listValue].S3File.fullyQualifiedUrl,
        target: "_blank"
      })), this.props.reportsById && this.props.reportsById[this.props.organization.id] && this.props.reportsById[this.props.organization.id][this.props.params.reportId] ? /*#__PURE__*/React.createElement(Preview, {
        template: this.props.reportsById[this.props.organization.id][this.props.params.reportId],
        reportType: "socialMediaSummary",
        reportView: true
      }) : /*#__PURE__*/React.createElement("div", null, this.props.loadingReport && /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 75
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })))));
    }
  }]);

  return SummaryReport;
}(Component)) || _class);
export default SummaryReport;